import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable} from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {

  private retryAttempts = Number(environment.retryAttempts);
  
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const skipRetry = req.headers.has('X-No-Retry');
    if (skipRetry) {
      const cleanReq = req.clone({
        headers: req.headers.delete('X-No-Retry')
      });
      return next.handle(cleanReq);
    }
    return next.handle(req).pipe(
      retry(this.retryAttempts)
    );
  }
}
